import httpClient from "@/services/httpClient";

export const getPresignedUrl = async ({ filename, requestId }) => {
  if (!requestId && !filename) {
    throw Error("Filename or requestId is required to upload a file");
  }

  const presignedUrlOptions = {
    upload: { filename },
  };
  if (requestId) {
    presignedUrlOptions.request_id = requestId;
  }

  try {
    const response = await httpClient.post(
      "/api/v1/uploads/presigned_url",
      presignedUrlOptions,
    );

    const { presigned_url, key } = response.data;
    return { presignedUrl: presigned_url, key };
  } catch (error) {
    const formattedError = new Error("Error getting presigned URL");
    formattedError.cause = error.response?.data?.error;
    throw formattedError;
  }
};

export const getExpiringUrl = async (key) => {
  try {
    const response = await httpClient.get(`/api/v1/uploads/expiring_url?key=${key}`);
    return response.data.expiring_url;
  } catch (error) {
    const formattedError = new Error("Error getting expiring URL");
    formattedError.cause = error.response?.data?.error;
    throw formattedError;
  }
};
